import { ToastContainer, Slide } from 'react-toastify';
import { NOTIFICATION_CONFIG } from '@/config/notification.config';

export const NotificationProvider = () => {
    return <ToastContainer transition={Slide} newestOnTop limit={NOTIFICATION_CONFIG.notification.maxToasts} />;
};
